import {ColumnStartOrder, ColumnBib, ColumnName, ColumnResult, ColumnQualification, ColumnRank, ColumnNoc } from "components/common/TableColumns"
import { ColumnRoute, ScoreTime } from "./TableColumns"
import { ColumnPty } from "../common/TableColumns"

export function leadColumns(hasRouteA, hasRouteB) {

    return (
        [
            ColumnRank({}),
            ColumnStartOrder({}),
            ColumnBib({label: 'HeaderBibNoR'}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnPty({}),
            ColumnRoute({route: 'A', disableSort: !hasRouteA}),
            ColumnRoute({route: 'B', disableSort: !hasRouteB}),
            ColumnResult({label: 'HeaderPoints'}),
            ScoreTime({}),
            ColumnQualification({})
        ]
    )
}

